import { motion } from "framer-motion";
import { Home, MapPinOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Page Not Found | Info Payangadi</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50 flex items-center justify-center p-6 pb-24">
        
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-white/80 backdrop-blur-xl p-10 rounded-[3rem] shadow-2xl border border-white/50 text-center max-w-md w-full relative overflow-hidden"
        >
          {/* പശ്ചാത്തലത്തിലെ ഒരു മങ്ങൽ ഇഫക്ട് */}
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-blue-100 rounded-full blur-3xl opacity-50 pointer-events-none"></div>
          <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-cyan-100 rounded-full blur-3xl opacity-50 pointer-events-none"></div>

          <motion.div 
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 15 }}
            className="inline-flex items-center justify-center p-6 bg-red-50 text-red-500 rounded-full mb-6 shadow-inner"
          >
            <MapPinOff size={64} strokeWidth={1.5} />
          </motion.div>

          <h1 className="text-7xl font-extrabold text-gray-900 tracking-tighter mb-2 drop-shadow-sm">
            4<span className="text-blue-600">0</span>4
          </h1>
          
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            വഴി തെറ്റിയോ?
          </h2>
          
          <p className="text-gray-500 mb-8 leading-relaxed">
            നിങ്ങൾ തിരയുന്ന പേജ് ഇവിടെ കണ്ടെത്താനായില്ല. ലിങ്ക് മാറിയതാകാം അല്ലെങ്കിൽ പേജ് നീക്കം ചെയ്തതാകാം.
          </p>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 w-full bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-2xl font-bold shadow-lg shadow-blue-200 transition-all"
          >
            <Home size={20} />
            Go back to Home
          </motion.button>

        </motion.div>

      </div>
    </>
  );
}